import React from 'react';
import { ApplicationView } from '@aha-app/mvc';
import Tool, { type ToolButtonComponent } from './Tool';
import ToolButton from '../toolbars/ToolButton';
import { svgToIcon } from '../utils/svg';
import addRowIcon from '../assets/icons/addRow.svg';
import { isTable } from '../objects/guards';

class ToolAddRowAbove extends Tool {
  static toolName = 'Insert row above';

  static action({ controller, selection }) {
    selection.addVector && selection.addVectorOnClick(true, true);
    this.toolActionComplete({ controller });
  }
}
class ToolAddRowBelow extends Tool {
  static toolName = 'Insert row below';

  static action({ controller, selection }) {
    selection.addVector && selection.addVectorOnClick(false, true);
    this.toolActionComplete({ controller });
  }
}

const AddRowButton: ToolButtonComponent = ApplicationView(
  ({ controller, selection, tool }) => {
    return (
      <span>
        <ToolButton
          onClick={() => {
            if (isTable(selection)) {
              selection.addVectorToEnd(true);
            }
            tool.toolActionComplete({ controller });
          }}
          tool={tool}
        >
          {svgToIcon(addRowIcon)}
        </ToolButton>
      </span>
    );
  }
);

class ToolAddRow extends Tool {
  static toolName = 'Add row';

  static buttonComponent() {
    return AddRowButton;
  }
}

export { ToolAddRow, ToolAddRowAbove, ToolAddRowBelow };
